(($) => {
    $(document).on('click', '.accordion-header', (e) => {
        e.preventDefault();

        const header = $(e.target);
        const item = header.closest('.accordion-item');

        item.toggleClass('show');
    });
})(jQuery);
